<div class="bg-[#fff] shadow-sm rounded-lg text-black ~p-4/6">
    <div class="flex flex-wrap justify-between items-center gap-6 space-y-4">
        <a
            (click)="cartService.toggleCart()"
            routerLink="/{{ languageService.getLanguageCode }}/hof/produkt/{{
                item().product.slug
            }}"
            class="order-1 shrink-0"
        >
            @if (
                item().product.images &&
                item().product.images?.length &&
                item().product.images!.length > 0
            ) {
                <img
                    class="rounded-md w-20 h-20 object-cover"
                    [src]="
                        domhandler.getSmallestImageAsWebp(
                            item().product.images![0]
                        )
                    "
                    [srcset]="
                        domhandler.generateSrcsetAsWebp(
                            item().product.images![0]
                        )
                    "
                    alt="imac image"
                />
            } @else {
                <div class="bg-gray-200 w-20 h-20"></div>
            }
        </a>

        <label for="counter-input" class="sr-only">Wähle Menge:</label>
        <div
            class="flex md:flex-row flex-col justify-between items-center order-3 ~gap-4/8"
        >
            <div class="flex items-center">
                <button
                    type="button"
                    id="decrement-button"
                    (click)="this.cartService.removeFromCart(item())"
                    data-input-counter-decrement="counter-input"
                    class="inline-flex justify-center items-center bg-gray-50 hover:bg-gray-200 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-100 w-5 h-5 shrink-0"
                >
                    <svg
                        class="w-2.5 h-2.5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 18 2"
                    >
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 1h16"
                        />
                    </svg>
                </button>
                <input
                    type="text"
                    id="counter-input"
                    data-input-counter
                    class="bg-transparent border-0 focus:outline-none focus:ring-0 w-10 font-medium text-sm text-center shrink-0"
                    placeholder=""
                    value="{{ item().amount }}"
                    disabled
                    required
                />
                <button
                    type="button"
                    id="increment-button"
                    (click)="
                        this.cartService.addToCart({
                            product: item().product,
                            selectedVariant: item().selectedVariant,
                            selectedDeliveryDate: item().selectedDeliveryDate,
                            amount: 1,
                        })
                    "
                    data-input-counter-increment="counter-input"
                    class="inline-flex justify-center items-center bg-gray-50 hover:bg-gray-200 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-100 w-5 h-5 shrink-0"
                >
                    <svg
                        class="w-2.5 h-2.5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 18 18"
                    >
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 1v16M1 9h16"
                        />
                    </svg>
                </button>
            </div>
            <p class="order-4 text-base text-end">
                {{ cartService.calculatePrice(item()) | customPrice }}
            </p>
        </div>

        <div class="flex-1 order-2 !mt-0 w-full min-w-0 max-w-md">
            <div>
                <a
                    (click)="cartService.toggleCart()"
                    routerLink="/{{
                        languageService.getLanguageCode
                    }}/hof/produkt/{{ item().product.slug }}"
                    class="font-medium text-base hover:underline"
                >
                    {{ item().product.name }}</a
                >
                <div class="text-gray-700">
                    @if (item().product.inventoryType === "weight") {
                        {{ item().selectedVariant.weight }}g
                    }
                    @if (item().selectedDeliveryDate) {
                        {{ item().selectedDeliveryDate?.date | customDate }}
                    }
                </div>
            </div>

            <div class="flex items-center gap-4">
                <button
                    type="button"
                    (click)="this.cartService.deleteFromCart(item())"
                    class="inline-flex items-center font-medium text-red-600 text-sm hover:underline"
                >
                    <svg
                        class="me-1.5 w-5 h-5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18 17.94 6M18 18 6.06 6"
                        />
                    </svg>
                    {{ "product.delete" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
